import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";

export type EditingRange = { from: number; to: number } | null;

export const editingPillKey = new PluginKey<EditingRange>("editingPill");

export const EditingPillExtension = Extension.create({
  name: "editingPill",
  addProseMirrorPlugins() {
    return [
      new Plugin<EditingRange>({
        key: editingPillKey,
        state: {
          init: () => null,
          apply(tr, prev) {
            const meta = tr.getMeta(editingPillKey) as EditingRange | undefined;
            if (meta !== undefined) return meta;
            if (tr.docChanged) return null;
            return prev;
          }
        },
        props: {
          decorations(state) {
            const range = editingPillKey.getState(state);
            if (!range) return null;
            return DecorationSet.create(state.doc, [Decoration.node(range.from, range.to, { class: "VariableInput__pill--editing" })]);
          }
        }
      })
    ];
  }
});
